import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../utils/api';
import { getApiErrorMessage } from '../../utils/errorUtils';
import { analytics } from '../../utils/analytics';
import PublicNavbar from '../Layout/PublicNavbar';
import SEO from '../Common/SEO';
import './Auth.css';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setUser, isAuthenticated } = useAuth();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');
  const processedRef = useRef(false);

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      setStatus('error');
      setMessage('No verification token provided');
      return;
    }

    // Prevent double-fire in StrictMode — verification must not hit the endpoint twice
    if (processedRef.current) return;
    processedRef.current = true;

    const controller = new AbortController();
    api.get(`/auth/verify-email?token=${token}`, { signal: controller.signal })
      .then(async (response) => {
        setStatus('success');
        setMessage(response.data.message || 'Email verified successfully');
        analytics.emailVerified();

        if (isAuthenticated) {
          try {
            const userResponse = await api.get('/auth/me');
            setUser(userResponse.data);
            localStorage.setItem('user', JSON.stringify(userResponse.data));
            setTimeout(() => navigate('/profile'), 2000);
          } catch (err) {
            setTimeout(() => navigate('/login'), 3000);
          }
        } else {
          setTimeout(() => navigate('/login'), 3000);
        }
      })
      .catch((error) => {
        if (error?.name === 'CanceledError' || error?.code === 'ERR_CANCELED') return;
        setStatus('error');
        setMessage(getApiErrorMessage(error, 'Verification failed'));
      });

    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SEO title="Verify Email" description="Verify your Options Tracker email address." />
      <PublicNavbar />
      <div className="auth-container">
      <div className="auth-card">
        <h2>Email Verification</h2>
        {status === 'verifying' && (
          <div>
            <p>Verifying your email address...</p>
          </div>
        )}
        {status === 'success' && (
          <div>
            <div className="alert alert-success">{message}</div>
            <p>Redirecting to login page...</p>
          </div>
        )}
        {status === 'error' && (
          <div>
            <div className="alert alert-error">{message}</div>
            <button className="btn btn-primary" onClick={() => navigate('/login')}>
              Go to Login
            </button>
          </div>
        )}
      </div>
    </div>
    </>
  );
}

export default VerifyEmail;


